import "./testimonials.scss";
import { useState, useEffect } from "react";
import googleLogo from "../../images/google-logo.svg";
import logo from "../../images/logo.svg";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import TestimonialsDataTable from "../../components/dataTable/TestimonialsDataTable";
import AddTestimony from "../../components/add/AddTestimony";


const Testimonials = () => {
  const [testomonyData, setTestimonyData] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: response } = await axiosPrivate.get('/testimonials');
        setTestimonyData(response?.sort((a, b) => new Date(b.testimonyDate.split("-").reverse().join("-")).getTime() - new Date(a.testimonyDate.split("-").reverse().join("-")).getTime()));
      } catch (error) {
        console.log(error.message);
      }
    }
    fetchData();
  }, [axiosPrivate]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
    {
      field: 'customerName',
      headerName: 'Customer Name',
      type: "string",
      width: 150
    },
    {
      field: 'verified',
      headerName: 'Verified',
      type: "boolean",
      width: 80,
    },
    {
      field: 'testimonyDate',
      headerName: 'Date',
      width: 100,
      type: "string",
    }, 
    {
      field: 'testimonyFrom',
      headerName: 'From',
      type: "string",
      width: 60,
      renderCell: (params) => {
        return <img src={params.row.testimonyFrom === "Shisha" ? logo : googleLogo} alt="" />
      }
    },
    {
      field: 'comments',
      headerName: 'Comments',
      type: "text",
      width: 350,
    },


  ];


  const [open, setOpen] = useState(false);
  return (
    <div className="testimonials">
      <div className="info">
        <h1>Testimonials</h1>
        <button onClick={() => setOpen(true)}>Add New Testimony</button>
      </div>
      <TestimonialsDataTable columns={columns} rows={testomonyData} />
      {open && <AddTestimony slug="testimony" columns={columns} setOpen={setOpen} />}
    </div>

  )
}

export default Testimonials